import React, { createContext, useContext, useState, useEffect } from 'react';

const CharacterContext = createContext();

export const useCharacter = () => {
  const context = useContext(CharacterContext);
  if (!context) {
    throw new Error('useCharacter must be used within a CharacterProvider');
  }
  return context;
};

export const CharacterProvider = ({ children }) => {
  const [hasWatchedIntro, setHasWatchedIntro] = useState(false);
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [showStoryViewer, setShowStoryViewer] = useState(false);

  // Check if user has watched intro before
  useEffect(() => {
    const watched = localStorage.getItem('cyberaegis_character_intro_watched');
    // Fix typo if it exists
    if (watched === 'failse') {
      localStorage.setItem('cyberaegis_character_intro_watched', 'false');
      setHasWatchedIntro(false);
    } else {
      setHasWatchedIntro(watched === 'true');
    }
  }, []);

  const markIntroAsWatched = () => {
    localStorage.setItem('cyberaegis_character_intro_watched', 'true');
    setHasWatchedIntro(true);
  };

  const showCharacterIntro = () => {
    setShowIntroModal(true);
  };

  const hideCharacterIntro = () => {
    setShowIntroModal(false);
  };

  const completeCharacterIntro = () => {
    markIntroAsWatched();
    setShowIntroModal(false);
  };

  const showStoryViewerModal = () => {
    setShowStoryViewer(true);
  };

  const hideStoryViewerModal = () => {
    setShowStoryViewer(false);
  };

  // Function to reset intro state for testing
  const resetIntroState = () => {
    localStorage.removeItem('cyberaegis_character_intro_watched');
    setHasWatchedIntro(false);
  };

  const value = {
    hasWatchedIntro,
    showIntroModal,
    showStoryViewer,
    showCharacterIntro,
    hideCharacterIntro,
    completeCharacterIntro,
    showStoryViewerModal,
    hideStoryViewerModal,
    resetIntroState
  };

  return (
    <CharacterContext.Provider value={value}>
      {children}
    </CharacterContext.Provider>
  );
};